import axiosIS from "@/api/net/axios.js"
import ApiConfig, { baseUrl } from "@/config/apiConfig.js"
import grobalConfig from "@/config/config.js";

export default {
  // SVC-邮箱登录(三方注册登录)
  // https://rg975ojk5z.feishu.cn/docx/Yrgrd964roO1cDxHgz8cc4HcnBh
  userLogin(data = {}) {
    return axiosIS(`${baseUrl}${ApiConfig.loginIn}`, data, { method: "post" })
  },
  userBind(data = {}) {
    return axiosIS(`${baseUrl}/api/user/bind`, data, { method: "post" })
  },
  // SVC-登出
  //   https://rg975ojk5z.feishu.cn/docx/DhN9d9zl1ojeryx2B6rcTay3ncd
  userLoginOut(data = {}, user_id) {
    return axiosIS(`${baseUrl}${ApiConfig.loginOut}/${user_id}`, data, { method: "post" })
  },
  // SVC-个人用户基本信息
  // https://rg975ojk5z.feishu.cn/docx/CZ9Wd29fRoxCVHxf6d9cbkrGnhc
  userGetInfo() {
    return axiosIS(`${baseUrl}${ grobalConfig.appname =='YinFeng' ? ApiConfig.getUserInfoCn: ApiConfig.getUserInfo}`, {}, { method: "get" })
  },
  // 获取验证码
  getVerifyCode(data = {}) {
    return axiosIS(`${baseUrl}/api/user/login/otp/message`, data, { method: "post" })
  },
  getVerifyCodeV1(data = {}) {
    return axiosIS(`${baseUrl}/api/user/login/otp/message/v1`, data, { method: "post" })
  },
  userPaySuccess(data = {}){
    return axiosIS(`${baseUrl}/api/payment/issue_report`, data, { method: "post" })
  }
}